import * as React from 'react';
import { Download, FileSpreadsheet, FileText, Table2 } from 'lucide-react';

import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { toast } from '../ui/sonner';
import { fleetReportsAPI, messageErreurRapport } from '../../lib/fleetReportsApi';

const FORMATS = [
  { value: 'pdf', label: 'PDF', icon: FileText },
  { value: 'xlsx', label: 'Excel', icon: FileSpreadsheet },
  { value: 'csv', label: 'CSV', icon: Table2 },
];

/**
 * Bouton « Télécharger » du rapport affiché, avec les filtres et le mois en
 * cours d'affichage. Le fichier porte un nom déjà rédigé.
 */
const ExportMenu = ({ etat, options, disabled = false }) => {
  const [enCours, setEnCours] = React.useState(false);

  const telecharger = async (format) => {
    setEnCours(true);
    try {
      await fleetReportsAPI.telecharger(etat, format, options);
      toast.success('Le fichier est téléchargé.');
    } catch (error) {
      toast.error(await messageErreurRapport(error, "Le fichier n'a pas pu être préparé."));
    } finally {
      setEnCours(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled || enCours}>
          <Download aria-hidden="true" />
          {enCours ? 'Préparation…' : 'Télécharger'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {FORMATS.map(({ value, label, icon: Icone }) => (
          <DropdownMenuItem key={value} onSelect={() => telecharger(value)}>
            <Icone className="mr-2 h-4 w-4" aria-hidden="true" />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
